module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rc-base-lookup plat-base-lookup"
  }, [(_vm.enableAdd && !_vm.readonly && !_vm.disabled) ? _c('div', {
    staticClass: "rc-base-lookup-add"
  }, [_c('rc-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-saas-add",
      "size": "10"
    },
    slot: "suffix"
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.showAddForm
    }
  }, [_vm._v(_vm._s(_vm.$_t('common.add', '新增')))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.lookupValue &&
    _vm.lookupValue.id &&
    (_vm.entity == 'systemuser' ||
      _vm.entity == 'new_srv_worker' ||
      _vm.entity == 'businessunit')
  ) ? _c('div', {
    staticClass: "rc-lookup-qywx"
  }, [(_vm.entity == 'businessunit') ? _c('rt-ww-open-data', {
    attrs: {
      "type": "departmentName",
      "openid": _vm.lookupValueName
    }
  }) : _c('rt-ww-open-data', {
    attrs: {
      "type": "userName",
      "openid": _vm.lookupValueName
    }
  }), _vm._v(" "), (!_vm.readonly && !_vm.disabled) ? _c('span', {
    staticClass: "el-input__suffix",
    on: {
      "click": _vm.clearData
    }
  }, [_vm._m(0)]) : _vm._e()], 1) : _c('el-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showJump),
      expression: "!showJump"
    }],
    staticClass: "plat-base-input",
    attrs: {
      "popper-class": _vm.lookupKey,
      "placeholder": _vm.placeholderValue,
      "disabled": _vm.disabled || _vm.readonly,
      "trigger-on-focus": false,
      "fetch-suggestions": _vm.findValueByApi,
      "readonly": _vm.closeQuickQuery
    },
    on: {
      "blur": _vm.blur,
      "select": _vm.selectValue,
      "focus": _vm.focus,
      "input": _vm.changeLookupValueName
    },
    model: {
      value: (_vm.lookupValueName),
      callback: function($$v) {
        _vm.lookupValueName = $$v
      },
      expression: "lookupValueName"
    }
  }, [(!_vm.disabled && !_vm.readonly) ? _c('rc-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-base-lookup"
    },
    on: {
      "click": _vm.showLookupDialog
    },
    slot: "suffix"
  }) : _vm._e(), _vm._v(" "), _vm._t("prefix", null, {
    "slot": "prefix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-input-shadow"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showJump),
      expression: "showJump"
    }],
    class: _vm.lookupValueReadOnly
  }, [_c('span', {
    staticClass: "jumpSpan",
    on: {
      "click": _vm.jumpNeedTips
    }
  }, [_vm._v(_vm._s(_vm.lookupValueName))]), _vm._v(" "), _c('div', {
    staticClass: "suffix-icon-wrap"
  }, [(!_vm.disabled && !_vm.readonly) ? _c('rc-icon', {
    staticClass: "lookup",
    attrs: {
      "slot": "suffix",
      "name": "rt-base-lookup"
    },
    on: {
      "click": _vm.showLookupDialog
    },
    slot: "suffix"
  }) : _vm._e()], 1), _vm._v(" "), _vm._t("prefix")], 2), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "entity": _vm.entity,
      "is-normal": _vm.isNormal,
      "request-url": _vm.requestUrl,
      "dependent-attribute-name": _vm.filterAttributeName,
      "dependent-relation-ship-name": _vm.dependentRelationShipName,
      "show-vlist": _vm.showVlist,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "filter-fields": _vm.dialogFilterFields,
      "condition-fields": _vm.conditionValue,
      "show-remove-dialog": _vm.showRemoveDialog,
      "count-type": _vm.countType,
      "return-total-record-count": _vm.returnTotalRecordCount,
      "is-watch-loading": _vm.isLookupWatchLoading,
      "default-view-logical-name": _vm.defaultViewLogicalName,
      "default-view-id": _vm.defaultViewId,
      "customer-data": _vm.customerData,
      "lookup-value": _vm.lookupValue,
      "to-entity": _vm.fullEditForm
    },
    on: {
      "data-selected": _vm.handleDataSelected,
      "dialogCallback": _vm._dialogCallback
    }
  }), _vm._v(" "), _c('rc-dialog', {
    class: _vm.isShowClass,
    attrs: {
      "custom-class": "plat-standard-dialog",
      "close-on-click-modal": false,
      "title": _vm.$_t('common.add', '新增'),
      "show-footer": false,
      "size": "large"
    },
    model: {
      value: (_vm.showFormDialog),
      callback: function($$v) {
        _vm.showFormDialog = $$v
      },
      expression: "showFormDialog"
    }
  }, [(_vm.showFormDialog) ? _c('vformcore', {
    attrs: {
      "form-logical-name": _vm.addFormLogicalName,
      "is-lookup-add": true,
      "object-type-name": _vm.entity,
      "form-type": 1,
      "to-entity": _vm.fullEditForm,
      "is-dialog-mode": ""
    },
    on: {
      "callback": _vm.vformcallback
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "el-input__suffix-inner"
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-circle-close"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b366288c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup/src/plat-lookup.vue
// module id = 2151
// module chunks = 228